// src/Panel/Admin_Panel/Utils/constants.js

// ============================================
// ✅ COLORS
// ============================================
export const COLORS = {
  primary: "#ff0055",
  primaryLight: "#ff4d88",
  primaryLighter: "#ff80aa",
  primaryDark: "#c2185b",

  success: "#52c41a",
  warning: "#faad14",
  danger: "#f5222d",
  info: "#1890ff",

  purple: "#722ed1",
  pink: "#eb2f96",
  yellow: "#faad14",
  green: "#52c41a",
  blue: "#1890ff",
  cyan: "#13c2c2",

  gray: "#8c8c8c",
  lightGray: "#f5f5f7",
  border: "#eeeeee",

  gradients: {
    pink: "linear-gradient(135deg, #ff0055, #ff4d88)",
    purple: "linear-gradient(135deg, #722ed1, #b37feb)",
    yellow: "linear-gradient(135deg, #faad14, #ffc53d)",
    green: "linear-gradient(135deg, #52c41a, #73d13d)",
    blue: "linear-gradient(135deg, #1890ff, #40a9ff)",
    cyan: "linear-gradient(135deg, #13c2c2, #36cfc9)",
  },
};

// ============================================
// ✅ STATUS COLORS
// ============================================
export const STATUS_COLORS = {
  active: { bg: "#e6f7e6", color: "#52c41a" },
  inactive: { bg: "#fff1f0", color: "#f5222d" },
  pending: { bg: "#fff7e6", color: "#faad14" },
  approved: { bg: "#e6f7e6", color: "#52c41a" },
  rejected: { bg: "#fff1f0", color: "#f5222d" },
  processing: { bg: "#e6f4ff", color: "#1890ff" },
  completed: { bg: "#e6f7e6", color: "#52c41a" },
  accepted: { bg: "#e6f7e6", color: "#52c41a" },
  success: { bg: "#e6f7e6", color: "#52c41a" },
  new: { bg: "#e6f4ff", color: "#1890ff" },
  resolved: { bg: "#e6f7e6", color: "#52c41a" },
  inprogress: { bg: "#fff7e6", color: "#faad14" },
  closed: { bg: "#f0f0f0", color: "#8c8c8c" },
};

// ============================================
// ✅ CHART COLORS
// ============================================
export const CHART_COLORS = [
  "#ff0055",
  "#722ed1",
  "#faad14",
  "#52c41a",
  "#1890ff",
  "#13c2c2",
];

// ============================================
// ✅ REFERENCE NUMBER PREFIXES
// ============================================
export const REF_PREFIX = {
  user: "USR-",
  staff: "STF-",
  dev: "DEV-",
  match: "MTCH-",
  payment: "PAY-",
  transaction: "TXN-",
  withdrawal: "WD-",
  plan: "PLAN-",
  commission: "COM-",
  contact: "CNT-",
};

// ============================================
// ✅ REPORT TITLES CONFIGURATION
// ============================================
export const REPORT_TITLES = {
  users: {
    title: "Users Report",
    subtitle: "Complete list of registered users on the platform",
    filename: "users_report",
  },
  staff: {
    title: "Staff Members Report",
    subtitle: "All staff members and their details",
    filename: "staff_report",
  },
  transactions: {
    title: "Transactions Report",
    subtitle: "All financial transactions across the platform",
    filename: "transactions_report",
  },
  revenue: {
    title: "Revenue Report",
    subtitle: "Admin revenue and commission breakdown",
    filename: "revenue_report",
  },
  withdrawals: {
    title: "Withdrawals Report",
    subtitle: "All withdrawal requests and their status",
    filename: "withdrawals_report",
  },
};

// ============================================
// ✅ COMPANY INFO FOR REPORTS
// ============================================
export const COMPANY_INFO = {
  name: "Matrimonial",
  tagline: "Admin Panel - Reports",
  copyright: "© 2025 Matrimonial. All rights reserved.",
  brandColor: [255, 0, 85], // RGB of primary color
};